/**
 * 展示alert信息，公共组件
 */
import Decorate from '@tencent/spaui-decorate'
import Dialog from '@tencent/spaui-dialog'

export const dialog = new Decorate(Dialog)

export const showComfirmAlert = (type, msg, props = {}) => {
    return new Promise((resolve, reject) => {
        dialog.setProps({
            onSubmit: () => {
                dialog.setProps({
                    show: false,
                })
                resolve(true)
            },
            onCancel: () => {
                dialog.setProps({
                    show: false,
                })
                reject()
            },
            submitBsStyle: type,
            show: true,
            time: 0,
            closeButton: false,
            cancelButton: false,
            type: 'confirm',
            iconType: type,
            children: msg,
            ...props,
        })
    })
}

export default showComfirmAlert
